<template>
<header class="header">
    <!-- Верхняя панель -->
    <div class="header_top-bar">
        <div class="logo" @click="goToHome"> 
            <img src="/img/photo_2025-08-19 11.36.18.jpeg" alt="Innfort">
        </div>
        <div class="top-bar-left">
          <a href="tel:+998998875888" class="header-phone">
            +998 99-887-58-88
          </a>
          <a href="mailto:info@medexsolution.uz" class="header-mail">
            info@medexsolution.uz
          </a>
        </div>

         <ul class="nav">
            <li>
                <a href="#">{{ $t('header.catalog')}}</a>
                <ul class="dropdown">
                    <li><a href="#" @click="goToInplants">{{  $t('header.first') }}</a></li>
                    <li><a href="#" @click="goToUnderwear">{{ $t('header.suit')}}</a></li>
                    <li><a href="#" @click="goToMedGel">{{ $t('header.medgel')}}</a></li>
                </ul>
            </li>
        </ul>
        <div class="top-bar-right">
            <span class="header-cer" @click="goToCertificate"><i class="fa-solid fa-box-archive"></i>{{ $t('header.header-cer')}}</span>
            <div class="header_top-bar-right">
                <a href="https://t.me/MedexSolution"><img src="/img/Telegram-icon-removebg-preview.png" class="fa-telegram" alt=""></a>
                <a href="https://www.instagram.com/silimed_uzbekistan?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="> <img src="/img/Instagram-icon-removebg-preview.png" class="fa-instagram" alt=""></a>
            </div>

            <div class="tab_switcher">
                <button 
                    @click="$i18n.locale = 'ru'" 
                    class="tab-btn" 
                    :class="{ 'active': $i18n.locale === 'ru' }"
                >
                    RU
                </button>
                <button 
                    @click="$i18n.locale = 'uz'" 
                    class="tab-btn" 
                    :class="{ 'active': $i18n.locale === 'uz' }"
                >
                  UZ
                </button>
            </div>

        </div>
    
    </div>
</header>

<div class="hero">
    <!-- Полосы-анимация -->
    <div class="stripes">
        <div></div><div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div><div></div>
        <div></div>
    </div>

    <!-- Контент -->
    <div class="hero-content">
        <div class="hero-text">
            <h2>{{ $t('header.Medex')}}</h2>
            <p>{{ $t('header.medexp')}}</p>
        </div>
        <div class="hero-img">
            <img src="/img/slaeder.webp" alt="Innfort">
        </div>
    </div>
</div>

</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

function goToHome() {
  router.push('/') // или '/home'
}
function goToInplants() {
  router.push('/inplants')
}
function goToUnderwear() {
  router.push('/underwear')
}
function goToMedGel() {
  router.push('/medgel')
}
function goToCertificate() {
  router.push('/certificate')
}
</script>
<script>
export default {
  methods: {
    switchLang(lang) {
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped>
.tab_switcher {
    display: flex;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 2px;
    position: relative;
}

.tab-btn {
    padding: 8px 20px;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 6px;
    z-index: 1;
    position: relative;
    min-width: 55px;
}

.tab-btn.active {
    color: white;
    background: #00a2a5;
    box-shadow: 0 2px 6px rgba(0, 162, 165, 0.3);
}

.tab-btn:hover:not(.active) {
    color: white;
    background: rgba(0, 162, 165, 0.2);
}

/* Адаптивность */
@media (max-width: 768px) {
    .tab_switcher {
        border-radius: 6px;
    }
    
    .tab-btn {
        padding: 6px 16px;
        font-size: 13px;
        min-width: 50px;
        border-radius: 5px;
    }
}

@media (max-width: 480px) {
    .tab-btn {
        padding: 5px 12px;
        font-size: 12px;
        min-width: 30px;
    }
}

@media (max-width: 360px) {
    .tab-btn {
        padding: 4px 10px;
        font-size: 11px;
        min-width: 40px;
    }
}
</style>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto";
}


/* ==== Doctors Carousel (dc-*) ==== */
:root { 
    --dc-teal:#00a2a5; 
    --dc-text:#333; 
    --dc-muted:#777; 
    --dc-border:#e6e6e6; 
}

body {
    margin: 0;
    font-family: "Roboto", "Open Sans", Arial, sans-serif;
    color: #333;
}

/* Верхняя темная панель */
.header_top-bar {
    background: #2e2e2e;
    color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 50px;
    width: 100%;
}

.header-phone {
    color: #fff;
    font-size: 13px;
    font-weight: 300;
    line-height: normal;
    position: relative;
    padding-left: 20px;
    text-decoration: none;
}

.fa-phone {
    position: absolute;
    top: 50%;
    left: 0;
    width: 14px;
    height: 14px;
    margin-top: -7px;
}

.header-mail{
    color: #fff;
    font-size: 13px;
    font-weight: 300;
    line-height: normal;
    margin-left: 62px;
    padding-left: 20px;
    text-decoration: none;
    display: flex;
    gap: 10px; 
    transition: 300ms;
    cursor: pointer;
}

.header-mail:hover{
    color: #00a2a5;
}

.header-cer{
    color: #fff;
    font-size: 13px;
    font-weight: 300;
    line-height: normal;
    padding-left: 28px;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: 300ms;
    cursor: pointer;
}

.header-cer:hover{
    color: #00a2a5;
}

.top-bar-right{
    display: flex;
    align-items: center;
    gap: 50px;
}

.top-bar-left, .top-bar-right {
    display: flex;
    align-items: center;
}

.header_top-bar-right{
    display: flex;
    align-items: center;
    gap: 10px;
}

.fa-telegram{
    width: 25px;
    height: 25px;
    transition: 300ms;
    background: #2e2e2e;
    cursor: pointer;
}

.fa-telegram:hover{
    color: #00a2a5;
}

.fa-instagram{
    width: 25px;
    height: 25px;
    transition: 300ms;
    background: #2e2e2e;
    cursor: pointer;
}

.fa-instagram:hover{
    color: #00a2a5;
}

/* Основная навигация */
.main-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 60px;
    background: #fff;
    border-bottom: 1px solid #eee;
}

.logo img {
    height: 45px;
    width: 45px;
    border-radius: 50%;
    cursor: pointer;
}

.nav {
    display: flex;
    gap: 35px;
    position: relative;
    flex-wrap: wrap;
}

.nav > li {
    list-style: none;
    position: relative;
}

.nav a {
    text-decoration: none;
    font-size: 12px;
    font-weight: 300;
    color: #ffffff;
    transition: 0.3s;
    padding: 5px 10px;
    display: inline-block;
}

.nav a:hover {
    color: #00a2a5;
}

/* Выпадающий каталог */
.dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 5px;
    min-width: 200px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    transition: 0.4s ease;
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    z-index: 1000;
}

.nav > li:hover .dropdown {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.dropdown li {
    list-style: none;
    border-bottom: 1px solid #f2f2f2;
}

.dropdown li:last-child {
    border-bottom: none;
}

.dropdown a {
    display: block;
    padding: 12px 20px;
    font-size: 14px;
    color: #333;
    transition: 0.3s;
}

.dropdown a:hover {
    background: #f8f8f8;
    color: #00a2a5;
    padding-left: 25px;
}


.lang_button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100px;
  height: 20px;
}


.lang_button button{
  font-size: 14px;
  font-family: Roboto;
  background: #00a2a5;
  border: 1px;
  border-radius: 5px;
  width: 50px;
  height: 100%;
  cursor: pointer;
  color: #ffffff;
  transition: 300ms;
} 

.lang_button button:hover{
  background: #ffffff;
  color: #00a2a5;
  transform: translateY(-1px);
} 

/* Герой секция */
.hero {
    position: relative;
    width: 100%;
    height: 426px;
    overflow: hidden;
    background: url('/public/img/phonk_header.webp') center/cover no-repeat;
}

/* Полосы */
.stripes {
    position: absolute;
    inset: 0;
    display: flex;
}

.stripes div {
    flex: 1;
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-100%);
    animation: drop 0.5s forwards ease-in;
}

/* Задержка для каждой полосы */
.stripes div:nth-child(1)  { animation-delay: 0s; }
.stripes div:nth-child(2)  { animation-delay: 0.05s; }
.stripes div:nth-child(3)  { animation-delay: 0.1s; }
.stripes div:nth-child(4)  { animation-delay: 0.15s; }
.stripes div:nth-child(5)  { animation-delay: 0.2s; }
.stripes div:nth-child(6)  { animation-delay: 0.25s; }
.stripes div:nth-child(7)  { animation-delay: 0.3s; }
.stripes div:nth-child(8)  { animation-delay: 0.35s; }
.stripes div:nth-child(9)  { animation-delay: 0.4s; }
.stripes div:nth-child(10) { animation-delay: 0.45s; }
.stripes div:nth-child(11) { animation-delay: 0.5s; }
.stripes div:nth-child(12) { animation-delay: 0.55s; }
.stripes div:nth-child(13) { animation-delay: 0.6s; }
.stripes div:nth-child(14) { animation-delay: 0.65s; }
.stripes div:nth-child(15) { animation-delay: 0.7s; }
.stripes div:nth-child(16) { animation-delay: 0.75s; }
.stripes div:nth-child(17) { animation-delay: 0.8s; }
.stripes div:nth-child(18) { animation-delay: 0.85s; }
.stripes div:nth-child(19) { animation-delay: 0.9s; }
.stripes div:nth-child(20) { animation-delay: 0.95s; }
.stripes div:nth-child(21) { animation-delay: 1s; }

@keyframes drop {
    to {
        transform: translateY(0);
    }
}

/* Контент героя */
.hero-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 50px;
}

.hero-text {
    text-align: center;
    color: #fff;
    opacity: 0;
    transform: translateY(30px);
    animation: fadeText 0.6s forwards 1.2s;
}

.hero-text h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.hero-text p {
    font-size: 1.8rem;
    font-weight: 300;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

@keyframes fadeText {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}










/* адаптив */

@media (min-width: 1440px) and (max-width: 1919px) {
  .hero { height: 500px; }
  .main-block { max-width: 1280px; gap: 56px; }
  .dc-container { max-width: 1280px; }
  .article-container { width: 1200px; margin-left: auto; margin-right: auto; }
  .header_top-bar { height: 56px; }
  .nav { gap: 42px; }
  .hero-text h2 { font-size: 2.4rem; }
  .hero-text p { font-size: 2.1rem; }
  .main { padding-top: 220px; padding-bottom: 220px; }
  .main-block { max-width: 1400px; gap: 64px; }
  .companyinfo { height: 880px; padding-left: 80px; padding-right: 80px; }
  .dc-container { max-width: 1400px; }
  .dc-card { height: 520px; }
  .article-container { width: 1280px; }
  .footer-block { max-width: 1400px; margin-left: auto; margin-right: auto; }
}

@media (min-width: 1200px) and (max-width: 1439px) {
  .main-block { max-width: 1140px; gap: 40px; padding: 0 16px; }
  .hero { height: 460px; }
  .article-container { width: 1100px; margin-left: auto; margin-right: auto; }
  .article-container { margin-left: auto !important; margin-right: auto !important; }
}

@media (min-width: 1024px) and (max-width: 1200px){
  .dc-card{flex:0 0 calc((100% - 22px)/2);}
  .main-nav { padding: 16px 32px; }
  .nav { gap: 24px; }
  .hero { height: 420px; }
  .hero-content { gap: 32px; }
  .main-block { max-width: 980px; gap: 32px; padding: 0 16px; }
  .implants-block-text { top: 70px; }
  .article-container { width: 960px; margin-left: auto; margin-right: auto; }
  /* Doctors: 3 per row */
  .dc-card { flex: 0 0 calc((100% - 44px)/3); margin: 0 8px; }
  .article-container { margin-left: auto !important; margin-right: auto !important; }
}


@media (max-width: 991px) {
  .hero {height: 350px;}
  .hero-content {padding: 0 20px;}
  .hero-img img {max-width: 80%;height: auto;}
  .main {padding-top: 100px;padding-bottom: 100px;}
  .brand {width: 100%;max-width: 400px;}
  .dc-section {padding-top: 100px;padding-bottom: 60px;}
  .dc-card {flex: 0 0 calc((100% - 22px)/2);height: auto;min-height: 400px;}
  .article-container {padding-top: 60px;}
  .lang_button {width: 20px;height: 20px;}
}

@media (min-width: 768px) and (max-width: 1023px) {
  .header_top-bar { padding: 0 16px; }
  .top-bar-right { gap: 20px; }
  .nav { gap: 16px; }
  .hero { height: 380px; }
  .hero-content { flex-direction: column; gap: 16px; padding: 0 16px; text-align: center; }
  .hero-img img { max-width: 80%; height: auto; display: block; margin: 0 auto; }
  .main { padding-top: 160px; padding-bottom: 160px; }
  .main-block { max-width: 740px; gap: 24px; padding: 0 16px; }
  .main-implants, .main-geli { min-height: 260px; }
  .implants-block-text { top: 48px; left: 16px; }
  .companyinfo { height: auto; background-attachment: scroll; padding: 60px 24px; margin-top: -120px; }
  .companyinfo h1, .companyinfo h3 { width: 100%; }
  .brands__container { gap: 20px; }
  .brand { width: 360px; height: 160px; }
  /* Doctors: 2 per row */
  .dc-card { flex: 0 0 calc((100% - 22px)/2); margin: 0 6px; height: 420px; }
  .dc-arrow { display: none; }
  .article-container { width: 100%; margin: 0 auto; padding: 20px; }
  .article-left, .article-right { max-width: 100%; }
  .footer-block { gap: 24px; padding-left: 16px; padding-right: 16px; }
  .lang_button {width: 20px;height: 20px;}
}

@media (min-width: 576px) and (max-width: 767px) {
  .header_top-bar { padding: 0 12px; gap: 12px;font-size: 12px; }
  .top-bar-left { display: none; } /* прячем левый блок, оставляем лого и иконки */
  .hero-text p { font-size: 1.4rem; }
  .main { padding-top: 120px; padding-bottom: 120px; }
  .main-block { flex-direction: column; gap: 16px; padding: 0 12px; }
  .companyinfo {padding: 40px 15px; margin-top: -100px; }
  .brand { width: 300px; height: 150px;padding: 20px 15px; }
  /* Doctors: 2 per row */
  .dc-card { flex: 0 0 calc((100% - 22px)/2); height: 400px; }
  .article-container { flex-direction: column; gap: 20px; margin: 0 auto; width: 100%; padding: 16px; }
  .footer-block { flex-direction: column; align-items: flex-start; gap: 16px; }
  .footer-logo img { margin-left: 0; }
  .lang_button button{width: 100%;} 
  .main-implants, .main-geli {margin-bottom: 20px;}
  .main-implants-span {font-size: 20px;}
  .nav {flex-wrap: wrap;justify-content: center;gap: 15px;}
  .hero {height: 300px;}
  .hero-text h2 {font-size: 1.5rem;}
  .stripes div {animation-delay: 0s !important;animation-duration: 0.3s;}
  .infomaintitle {font-size: 20px;}
  .companydiscript {font-size: 14px;}
  #invo {width: 150px;height: 120px;margin-top: 15px;}
  .dc-title {font-size: 18px;}
  .dc-card {flex: 0 0 100%;margin: 0 10px;}
  .dc-arrow {display: none;}
  .article-overlay h2 {font-size: 16px;}
  .artbtn {font-size: 14px;padding: 6px 12px;}
  .article-right h3 {font-size: 20px;}
  .lang_button {width: 20px;height: 20px;}
}



@media (max-width: 640px){
  .dc-title{font-size:18px;}
  .dc-card{flex:0 0 100%;}
  .dc-arrow{display:none;} /* на мобиле листаем свайпом/точками */
  .lang_button {width: 20px;height: 20px;}
}

@media (max-width: 575px) {
  .header_top-bar { padding: 0 10px; gap: 10px; }
  .logo img { height: 50px; width: 50px; }
  .top-bar-left { display: none; } /* экономим место */
  .top-bar-right { gap: 16px; }
  .nav { position: static; }
  .dropdown { left: 0; right: 0; width: auto; }
  .hero { height: 300px; }
  .hero-content {width: 100%;height: 100%; gap: 12px; padding: 0 12px; }
  .hero-text h2 { font-size: 1.4rem; }
  .hero-text p { font-size: 1.2rem; }
  .main { padding-top: 100px; padding-bottom: 100px; }
  .main-block { flex-direction: column; gap: 14px; padding: 0 12px; }
  .main-implants, .main-geli { min-height: 240px; }
  .implants-block-text { top: 36px; left: 12px; }
  .companyinfo { padding: 36px 12px; margin-top: -80px; }
  .brands__container { gap: 16px; }
  .brand { width: 260px; height: 120px; }
  .dc-card { flex: 0 0 100%; height: 380px; margin: 0; }
  .dc-dots { justify-content: center; }
  .article-container { flex-direction: column; gap: 16px; width: 100%; margin: 0 auto; padding: 12px; }
  .article-right h3 { font-size: 20px; }
  .article-item a { font-size: 15px; }
  .footer-block { flex-direction: column; gap: 14px; padding: 24px 12px; }
  .footer-locations { width: 100%; }
  .map-btn { width: 100%; text-align: center; margin-right: 0; }
  .lang_button button{width: 100%;} 

  .header-phone, .header-mail, .header-cer {font-size: 11px;padding-left: 18px;}
  .hero {height: 250px;}
  .hero-text h2 {font-size: 1.2rem;}
  .hero-text p {font-size: 1rem;}
  .main {padding-top: 60px;padding-bottom: 60px;}
  .companyinfo {padding: 30px 10px;}
  .infomaintitle {font-size: 18px;}
  .companydiscript {font-size: 13px;}
  .brand {height: 120px;}
  #invo {width: 120px;height: 100px;margin-top: 10px;}
  .dc-section {padding: 30px 10px;}
  .dc-title {font-size: 16px;margin-bottom: 20px;}
  .dc-name {font-size: 14px;}
  .dc-btn {font-size: 11px;padding: 8px 12px;height: 40px;}
  .article-container {padding: 20px 10px;gap: 20px;}
  .article-overlay {padding: 10px;}
  .article-overlay h2 {font-size: 14px;margin-bottom: 5px;}
  .artbtn {font-size: 12px;padding: 5px 10px;}
  .article-right h3 {font-size: 18px;}
  .article-item .date {font-size: 12px;}
  .article-item a {font-size: 14px;}
  .article-item .time {font-size: 12px;}
  .footer {padding: 30px 15px 20px;}
  .footer-block {padding: 20px 15px;gap: 20px;}
  .footer-logo img {width: 80px;}
  .footer-title {font-size: 16px;}
  .map-btn {font-size: 12px;padding: 8px 12px;}
  .footer-copyright {font-size: 12px;margin-top: -20px;}
  .lang_button {width: 20px;height: 20px;}
}

@media (max-width: 425px) {
  .hero { height: 200px; }
  .hero-text h2 { font-size: 1.2rem; }
  .hero-text p { font-size: 1.05rem; }
  .dc-card { height: 360px; }
  .article-right h3 { font-size: 18px; }
  .lang_button button{width: 100%;} 
  .lang_button {width: 20px;height: 20px;gap: 10px; order: -1;}

  .header_top-bar {
        flex-direction: column;
        height: auto;
        padding: 10px;
    }
    
    .header_top-bar > * {
        margin: 5px 0;
    }
    
    .top-bar-right {
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;
    }
    
    .header-cer {
        font-size: 11px;
        padding-left: 20px;
    }
    
}

@media (max-width: 380px) {
  .hero { height: 200px; }
  .hero-text h2 { font-size: 1.2rem; }
  .hero-text p { font-size: 1.05rem; }
  .dc-card { height: 360px; }
  .article-right h3 { font-size: 18px; }
  .lang_button button{width: 100%;} 
  .lang_button {width: 20px;height: 20px;gap: 10px; order: -1;}

  .header_top-bar {
        flex-direction: column;
        height: auto;
        padding: 10px;
    }
    
    .header_top-bar > * {
        margin: 5px 0;
    }
    
    .top-bar-right {
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;
    }
    
    .header-cer {
        font-size: 11px;
        padding-left: 20px;
    }
    
}

@media (max-width: 360px) and (max-width: 320px) {
  .header-phone, .header-mail, .header-cer {font-size: 10px;}
  .hero-text h2 {font-size: 1rem;}
  .hero-text p {font-size: 0.9rem;}
  .infomaintitle {font-size: 16px;}
  .companydiscript {font-size: 12px;}
  .dc-title {font-size: 15px;}
  .article-right h3 {font-size: 16px;}
  .logo img { height: 100px; width: 100px; }
  .lang_button {width: 20px;height: 20px;display: flex;order: -1;flex-direction: column;}

   .header_top-bar {
        flex-direction: column;
        height: auto;
        padding: 10px;
    }
    
    .header_top-bar > * {
        margin: 5px 0;
    }
    
    .top-bar-right {
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;
    }
    
    .header-cer {
        font-size: 11px;
        padding-left: 20px;
    }
    
   
}
</style>